module.exports = __webpack_public_path__ + "static/img/file.80d65de2.svg";